import http from 'hub-http/clients/apiClient';
import { FETCH_GOAL_TARGETS_OVERRIDE_PERMISSION_URL, GOAL_EDIT_PERMISSION_URL } from '../constants/api';
import { logError } from '../utils/errorHandling';
import { getGoalTargetRequestSorts } from '../utils/goal';
export const fetchGoalTargets = (dataQuery, selectedSortColumn, selectedSortDirection) => {
  const GOAL_TARGET_OBJECT_ID = '0-74';
  const properties = ['objectId', 'hs_group_correlation_uuid', 'hs_goal_type', 'hs_target_amount', 'hs_milestone', 'hs_status', 'hs_assignee_user_id', 'hs_assignee_team_id', 'hs_goal_target_group_id', 'hs_kpi_progress_percent', 'hs_kpi_value', 'hs_kpi_value_last_calculated_at', 'hs_participant_type', 'hs_start_datetime', 'hs_end_datetime', 'hs_owner_ids_of_all_owners', 'hs_pipelines', 'hs_fiscal_year_offset', 'hs_is_forecastable', 'hs_kpi_property_name', 'hs_kpi_metric_type', 'hs_kpi_object_type', 'hs_kpi_value', 'hs_goal_name', 'hs_ad_campaign_asset_ids', 'hs_ad_account_asset_ids', 'hs_contact_lifecycle_stage', 'hs_kpi_single_object_custom_goal_type_name', 'hs_kpi_tracking_method', 'hs_kpi_time_period_property', 'hs_kpi_unit_type', 'hs_kpi_filter_groups'];
  return http.post(FETCH_GOAL_TARGETS_OVERRIDE_PERMISSION_URL, {
    data: Object.assign({
      objectTypeId: GOAL_TARGET_OBJECT_ID,
      requestOptions: {
        properties
      },
      sorts: getGoalTargetRequestSorts(selectedSortDirection, selectedSortColumn)
    }, dataQuery)
  }).then(data => data).catch(logError);
};
export const fetchEditableGoalTargetIds = query => {
  const dataQuery = {
    query
  };
  return http.get(GOAL_EDIT_PERMISSION_URL, dataQuery).then(response => response);
};